import React from 'react';
import { CheckCircleOutlined, RocketLaunchOutlined } from '../icons';
import { getDaysUntilExam } from '../utils/examCountdown';
import { trackButtonClick } from '../analytics';
import './UpgradeCTA.css';

export const HOTMART_URL = 'https://pay.cakto.com.br/ae6oydd_1033150';
const WHATSAPP_GROUP_URL = 'https://chat.whatsapp.com/LNeuw6jblVl2Bv171V0592?mode=gi_t';

const DEFAULT_BENEFITS = [
  'Simulados completos',
  'Questões comentadas',
  'Estatísticas de desempenho',
  'Conteúdo focado no edital'
];

function WhatsappIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
      <path d="M20.52 3.48A11.94 11.94 0 0012 0C5.373 0 0 5.373 0 12c0 2.116.553 4.178 1.6 6.02L0 24l6.097-1.586A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12 0-3.204-1.249-6.207-3.48-8.52z" fill="#25D366" />
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.472-.148-.672.15-.198.297-.767.967-.94 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.173.198-.297.297-.495.099-.198.05-.372-.025-.52-.074-.148-.672-1.617-.921-2.219-.242-.583-.487-.504-.672-.513l-.572-.01c-.198 0-.52.074-.793.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.077 4.487 2.982 1.288 2.982.858 3.518.806.536-.049 1.758-.718 2.005-1.412.248-.695.248-1.289.173-1.412-.074-.124-.273-.198-.57-.347z" fill="#fff" />
    </svg>
  );
}

// CTA de venda reutilizável (modal de trial, resultado do simulado grátis, banner do dashboard).
// Centraliza copy/preço/benefícios num só lugar para manter consistência entre os pontos de venda.
function UpgradeCTA({
  variant = 'inline',
  title = 'Continue praticando até a prova da Polícia Penal RS',
  subtitle = 'Desbloqueie agora simulados, comentários e estatísticas completas.',
  benefits = DEFAULT_BENEFITS,
  showWhatsapp = true,
  showCountdown = true,
  trackingPrefix = 'upgrade_cta',
  onClose
}) {
  const daysLeft = showCountdown ? getDaysUntilExam() : null;

  return (
    <div className={`upgrade-cta upgrade-cta--${variant}`}>
      {onClose && (
        <button className="upgrade-cta-close" onClick={onClose} aria-label="Fechar">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      )}

      <div className="upgrade-cta-body">
        <div className="upgrade-cta-text">
          <h3 className="upgrade-cta-title">{title}</h3>
          {subtitle && <p className="upgrade-cta-subtitle">{subtitle}</p>}

          {benefits?.length > 0 && (
            <ul className="upgrade-cta-benefits">
              {benefits.map((benefit) => (
                <li key={benefit}>
                  <CheckCircleOutlined style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 6 }} />
                  {benefit}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="upgrade-cta-actions">
          <a
            className="upgrade-cta-button primary"
            href={HOTMART_URL}
            onClick={() => trackButtonClick(`${trackingPrefix}_liberar_acesso`)}
          >
            <RocketLaunchOutlined style={{ fontSize: 18, verticalAlign: 'middle', marginRight: 6 }} />
            Liberar acesso completo
          </a>
          {showWhatsapp && (
            <a
              className="upgrade-cta-button whatsapp"
              href={WHATSAPP_GROUP_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackButtonClick(`${trackingPrefix}_whatsapp`)}
            >
              <WhatsappIcon />
              Aproveite nosso grupo do WhatsApp com questões extras
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default UpgradeCTA;
